{
	"language": {
		"aria": "Endre språk"
	},
	"placeholder": {
		"title": "Kandidatsenteret ditt er på vei",
		"body": "Det er ingenting her ennå. Vi sender deg en lenke på e-post så snart det er klart."
	},
	"not_found": {
		"title": "Fant ikke siden",
		"body": "Sjekk lenken du fulgte, eller bruk lenken fra e-posten din."
	},
	"error_boundary": {
		"reload": "Last inn siden på nytt"
	},
	"login": {
		"loading": "Laster…",
		"title": "Logg inn på kandidatsenteret ditt",
		"intro": "Skriv inn e-postadressen din for å se søknadene dine.",
		"email_label": "E-postadresse",
		"email_placeholder": "deg@eksempel.no",
		"submit": "Logg inn",
		"sending": "Sender…",
		"sent": {
			"title": "Sjekk e-posten din",
			"body": "Hvis {{email}} samsvarer med en søknad, er en innloggingslenke på vei.",
			"retry": "Fikk du den ikke? Sjekk adressen og prøv igjen"
		},
		"resent": {
			"title": "Vi har sendt deg en ny innloggingslenke",
			"body": "Lenken du åpnet har utløpt. Hvis e-postadressen din samsvarer med en søknad, er en ny innloggingslenke på vei. Den åpner samme side.",
			"request_manually": "Fikk du den ikke? Be om en ny lenke"
		},
		"request_error": {
			"throttled": "For mange forsøk. Vent et minutt og prøv igjen.",
			"invalid_email": "Skriv inn en gyldig e-postadresse.",
			"generic": "Noe gikk galt. Prøv igjen."
		},
		"unknown_organisation": {
			"title": "Fant ikke siden",
			"body": "Sjekk lenken du fulgte, eller bruk lenken fra e-posten din."
		},
		"error": {
			"title": "Noe gikk galt",
			"body": "Vi kunne ikke laste denne siden. Prøv igjen om et øyeblikk."
		}
	},
	"organisations": {
		"title": "Søknadene dine",
		"intro": "Velg en bedrift for å se søknadene du har sendt til dem.",
		"count_one": "{{count}} søknad",
		"count_other": "{{count}} søknader",
		"empty": {
			"title": "Ingen søknader ennå",
			"body": "Så snart du søker hos en bedrift, dukker den opp her."
		},
		"error": "Vi kunne ikke laste bedriftene dine. Prøv igjen om et øyeblikk.",
		"log_out": "Logg ut",
		"logging_out": "Logger ut…"
	},
	"submissions": {
		"title": "Tidligere søknader",
		"back_to_organisations": "Alle bedrifter",
		"cv_uploaded": "CV lastet opp",
		"empty": {
			"title": "Ingen søknader ennå",
			"body": "Søknader du sender til {{organisation}} dukker opp her."
		},
		"error": "Vi kunne ikke laste søknadene dine. Prøv igjen om et øyeblikk.",
		"log_out": "Logg ut",
		"logging_out": "Logger ut…"
	},
	"profile": {
		"link": {
			"title": "Profilen din",
			"cv_added": "CV lagt til",
			"cv_missing": "Ingen CV ennå"
		},
		"back": "Tilbake til søknaden",
		"context": "{{campaign}} · {{organisation}}",
		"contact_consent": "Du har sagt ja til å bli kontaktet om denne stillingen.",
		"cv": {
			"title": "CV",
			"upload": {
				"title": "Last opp CV-en din",
				"drop_hint": "eller dra og slipp den her",
				"constraints": "{{types}}, maks {{size}} MB",
				"uploading": "Laster opp {{fileName}}…",
				"done": "CV lastet opp",
				"error_type": "Denne filtypen støttes ikke. Tillatte typer: {{types}}.",
				"error_size": "Filen er for stor. Maksimal størrelse er {{size}} MB."
			},
			"remove": {
				"label": "Fjern {{fileName}}",
				"question": "Fjerne {{fileName}}?",
				"consequence": "Arbeidsgiveren vil ikke lenger kunne se den. Dette kan ikke angres.",
				"confirm": "Fjern CV",
				"cancel": "Avbryt",
				"removing": "Fjerner…",
				"error": "Kunne ikke fjerne CV-en din. Prøv igjen."
			}
		},
		"work_history": {
			"title": "Arbeidserfaring",
			"description": "Fortell oss om relevant arbeidserfaring: hvor du har jobbet, hva du gjorde der, og hvor lenge du jobbet der. Du kan legge til mer enn én jobb hvis de er relevante.",
			"placeholder": "Beskriv en jobb du har hatt",
			"input_label": "Jobbdetaljer",
			"save": "Lagre",
			"saving": "Lagrer…",
			"cancel": "Avbryt",
			"edit": "Rediger",
			"remove": "Fjern",
			"add_another": "Legg til en jobb til",
			"error_empty": "Skriv noe før du lagrer.",
			"error_limit": "Du kan legge til opptil {{max}} jobber.",
			"unsaved_changes": "Du har ulagrede endringer i arbeidserfaringen din. Vil du forlate siden likevel og miste dem?",
			"hints": {
				"label": "Detaljer om denne jobben",
				"included": "nevnt",
				"missing": "ikke nevnt ennå"
			}
		},
		"education": {
			"title": "Utdanning",
			"description": "Fortell oss om relevant utdanning: hva du har studert, hvor og når. Grader, skoler, kurs og sertifikater teller alle. Du kan legge til mer enn én.",
			"placeholder": "Beskriv en grad, skole eller et kurs",
			"input_label": "Utdanningsdetaljer",
			"save": "Lagre",
			"saving": "Lagrer…",
			"cancel": "Avbryt",
			"edit": "Rediger",
			"remove": "Fjern",
			"add_another": "Legg til en utdanning til",
			"error_empty": "Skriv noe før du lagrer.",
			"error_limit": "Du kan legge til opptil {{max}} utdanninger.",
			"unsaved_changes": "Du har ulagrede endringer i utdanningen din. Vil du forlate siden likevel og miste dem?"
		},
		"licenses": {
			"title": "Bevis og sertifikater",
			"description": "Fortell oss om bevis og sertifikater du har, for eksempel førerkort, truckførerbevis eller hygienekurs. Skriv når du fikk det, og når det utløper, hvis det gjør det. Du kan legge til mer enn ett.",
			"placeholder": "Beskriv et bevis eller sertifikat",
			"input_label": "Detaljer om beviset",
			"save": "Lagre",
			"saving": "Lagrer…",
			"cancel": "Avbryt",
			"edit": "Rediger",
			"remove": "Fjern",
			"add_another": "Legg til et bevis til",
			"error_empty": "Skriv noe før du lagrer.",
			"error_limit": "Du kan legge til opptil {{max}} bevis.",
			"unsaved_changes": "Du har ulagrede endringer i bevisene dine. Vil du forlate siden likevel og miste dem?"
		}
	},
	"submission": {
		"back": "Tilbake til søknadene mine",
		"back_short": "Tilbake",
		"not_found": {
			"title": "Fant ikke søknaden",
			"body": "Denne søknaden finnes ikke, eller den er ikke din."
		},
		"result": {
			"heading": "Bekreftelsesskjermen du så etter at du søkte"
		},
		"summary": {
			"title": "Oppsummering av svarene dine",
			"submitted_on": "Du sendte inn dette skjemaet",
			"submitted_more_than_once": "Du fylte ut dette skjemaet mer enn én gang. Vi slår automatisk sammen profilen din; søknaden nedenfor er den nyeste."
		}
	}
}
